module.exports = __webpack_public_path__ + "static/media/plusBlack.2215773b.svg";